<quill-view [content]="contentHTML"></quill-view>